const STOREFRONT_TOKEN = 'cf87a8fb4d55f219affe7f198e710eaa';
const STORE_DOMAIN = window.SSWEB_STORE_DOMAIN;

// Centralised filter config — note: 'equpment_make' typo matches the actual Shopify metafield key
const FILTER = {
  TYPE:  { namespace: 'pdflow', key: 'equipment_type',  filterId: 'filter.p.m.pdflow.equipment_type'  },
  MAKE:  { namespace: 'pdflow', key: 'equpment_make',   filterId: 'filter.p.m.pdflow.equpment_make'   },
  MODEL: { namespace: 'pdflow', key: 'equipment_model', filterId: 'filter.p.m.pdflow.equipment_model' },
};

const MAX_PAGINATION_PAGES = 20;

// Cache: model GID → product URL
const modelProductUrls = {};


async function fetchMetaobjectLabels(gids) {
  const query = `{
    nodes(ids: ${JSON.stringify(gids)}) {
      ... on Metaobject {
        id
        fields { key value }
      }
    }
  }`;

  const { data } = await storefrontFetch(query);
  const labelMap = {};

  (data?.nodes || []).forEach(node => {
    if (!node) return;
    const labelField = node.fields.find(f =>
      f.key === 'model_name' || f.key === 'name' || f.key === 'title'
    );
    if (labelField) labelMap[node.id] = labelField.value;
  });

  return labelMap;
}

// Converts Shopify filter value ID (e.g. "gid-shopify-metaobject-12345") to a proper GID
function filterValueIdToGid(valueId) {
  const match = valueId.match(/gid-shopify-([a-z]+)-(\d+)$/i);
  if (!match) {
    console.warn(`filterValueIdToGid: unexpected format "${valueId}"`);
    return null;
  }
  const type = match[1].charAt(0).toUpperCase() + match[1].slice(1);
  return `gid://shopify/${type}/${match[2]}`;
}

async function storefrontFetch(query, variables = {}) {
  const response = await fetch(`https://${STORE_DOMAIN}/api/2025-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
    },
    body: JSON.stringify({ query, variables })
  });
  return response.json();
}

async function fetchFilters(appliedFilters = []) {
  const filterArgs = appliedFilters.map(({ namespace, key, value }) =>
    `{productMetafield: {namespace: "${namespace}", key: "${key}", value: "${value}"}}`
  ).join(', ');

  const query = `{
    search(query: "*", first: 1, types: PRODUCT, unavailableProducts: SHOW${filterArgs ? `, productFilters: [${filterArgs}]` : ''}) {
      productFilters {
        id
        values { id label }
      }
    }
  }`;

  const { data } = await storefrontFetch(query);
  return data?.search?.productFilters || [];
}

async function fetchProductUrlsForModels(typeGid, makeGid) {
  // Build into a local map first, then assign atomically
  const localMap = {};

  let hasNextPage = true;
  let endCursor = null;
  let page = 0;

  while (hasNextPage && page < MAX_PAGINATION_PAGES) {
    page++;

    const filterArgs = [];
    if (typeGid) filterArgs.push(`{productMetafield: {namespace: "${FILTER.TYPE.namespace}", key: "${FILTER.TYPE.key}", value: "${typeGid}"}}`);
    if (makeGid) filterArgs.push(`{productMetafield: {namespace: "${FILTER.MAKE.namespace}", key: "${FILTER.MAKE.key}", value: "${makeGid}"}}`);

    const query = `
      query($cursor: String) {
        search(
          query: "*"
          first: 250
          after: $cursor
          types: PRODUCT
          unavailableProducts: SHOW
          ${filterArgs.length ? `productFilters: [${filterArgs.join(', ')}]` : ''}
        ) {
          edges {
            node {
              ... on Product {
                onlineStoreUrl
                equipment_model: metafield(namespace: "${FILTER.MODEL.namespace}", key: "${FILTER.MODEL.key}") { value }
              }
            }
          }
          pageInfo { hasNextPage endCursor }
        }
      }
    `;

    const { data } = await storefrontFetch(query, { cursor: endCursor });
    const edges = data?.search?.edges || [];

    edges.forEach(({ node }) => {
      const modelGid = node.equipment_model?.value;
      if (modelGid && node.onlineStoreUrl) {
        const path = new URL(node.onlineStoreUrl).pathname;
        localMap[modelGid] = path;
      }
    });

    hasNextPage = data?.search?.pageInfo?.hasNextPage || false;
    endCursor = data?.search?.pageInfo?.endCursor || null;
  }

  if (page >= MAX_PAGINATION_PAGES) {
    console.warn(`fetchProductUrlsForModels: reached pagination limit (${MAX_PAGINATION_PAGES} pages). Some models may be missing.`);
  }

  // Atomic swap
  Object.keys(modelProductUrls).forEach(k => delete modelProductUrls[k]);
  Object.assign(modelProductUrls, localMap);
}

function populateSelect(select, values, placeholderText) {
  while (select.options.length > 1) select.remove(1);

  if (!values || values.length === 0) {
    const none = document.createElement('option');
    none.value = '';
    none.textContent = placeholderText || 'No options available';
    none.disabled = true;
    select.appendChild(none);
    return;
  }

  const sorted = [...values].sort((a, b) => a.label.localeCompare(b.label));
  sorted.forEach(({ id, label }) => {
    const gid = filterValueIdToGid(id);
    if (!gid) return;
    const option = document.createElement('option');
    option.value = gid;
    option.textContent = label;
    select.appendChild(option);
  });
}

function updateSearchButtonState() {
  const typeSelect  = document.getElementById('equipment-type');
  const makeSelect  = document.getElementById('make');
  const modelSelect = document.getElementById('model');
  const searchButton = document.getElementById('ssweb-search');
  if (!searchButton) return;

  const hasValue = [typeSelect, makeSelect].every(el => el?.value);
  searchButton.disabled = !hasValue;
}

function resetForm() {
  const typeSelect  = document.getElementById('equipment-type');
  const makeSelect  = document.getElementById('make');
  const modelSelect = document.getElementById('model');

  if (typeSelect) {
    typeSelect.value = '';
    typeSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (makeSelect) {
    makeSelect.classList.remove('loading');
    makeSelect.value = '';
    makeSelect.disabled = true;
  }

  if (modelSelect) {
    modelSelect.classList.remove('loading');
    modelSelect.value = '';
    modelSelect.disabled = true;
    while (modelSelect.options.length > 1) modelSelect.remove(1);
  }

  Object.keys(modelProductUrls).forEach(k => delete modelProductUrls[k]);
  updateSearchButtonState();
}

function setupFormSubmission() {
  const form = document.getElementById('ssweb-filter-form');
  if (!form) {
    console.warn('Form with id "ssweb-filter-form" not found');
    return;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    const modelSelect = document.getElementById('model');
    const modelGid = modelSelect?.value;

    // Model selected → go directly to its product page
    if (modelGid && modelProductUrls[modelGid]) {
      window.location.href = modelProductUrls[modelGid];
      return;
    }

    // Type/Make only → redirect to collection with Shopify filter params
    // Shopify collection filter URLs expect the format:
    //   filter.p.m.{namespace}.{key}=gid-shopify-{type}-{id}
    const params = new URLSearchParams();
    const typeSelect = document.getElementById('equipment-type');
    const makeSelect = document.getElementById('make');

    if (typeSelect?.value) {
      params.append(FILTER.TYPE.filterId, typeSelect.value);
    }
    if (makeSelect?.value) {
      params.append(FILTER.MAKE.filterId, makeSelect.value);
    }

    const qs = params.toString();
    window.location.href = qs ? `/collections/all?${qs}` : '/collections/all';
  });

  const resetButton = document.getElementById('ssweb-reset');
  if (resetButton) {
    resetButton.addEventListener('click', function (e) {
      e.preventDefault();
      resetForm();
    });
  }
}

async function initDropdowns() {
  const typeSelect  = document.getElementById('equipment-type');
  const makeSelect  = document.getElementById('make');
  const modelSelect = document.getElementById('model');


  async function restoreFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const typeGid = params.get(FILTER.TYPE.filterId);
    const makeGid = params.get(FILTER.MAKE.filterId);

    if (typeGid) {
      typeSelect.value = typeGid;
      makeSelect.disabled = false;
    }
    if (makeGid) {
      makeSelect.value = makeGid;
      await onMakeChange();
    }

    updateSearchButtonState();
  }

  if (!typeSelect || !makeSelect || !modelSelect) {
    console.warn('One or more select elements not found');
    return;
  }

  modelSelect.disabled = true;
  makeSelect.disabled = true;

  // Show loading state on Type and Make during initial fetch
  typeSelect.disabled = true;
  typeSelect.classList.add('loading');

  try {
    const filters = await fetchFilters();
    const typeValues = filters.find(f => f.id === FILTER.TYPE.filterId)?.values;
    const makeValues = filters.find(f => f.id === FILTER.MAKE.filterId)?.values;
    populateSelect(typeSelect, typeValues);
    populateSelect(makeSelect, makeValues);
  } catch (error) {
    console.error('Error loading initial filters:', error);
  } finally {
    typeSelect.disabled = false;
    typeSelect.classList.remove('loading');

    if (window.location.pathname.startsWith('/collections')) {
      await restoreFromUrl();
    }
  }

  async function onTypeChange() {
    const typeGid = typeSelect.value;

    makeSelect.disabled = !typeGid;
    if(!typeGid) {
      makeSelect.value = '';
    }

    // Reset model
    while (modelSelect.options.length > 0) modelSelect.remove(0);
    const defaultModelOption = document.createElement('option');
    defaultModelOption.value = '';
    defaultModelOption.textContent = 'Select Model';
    defaultModelOption.selected = true;
    defaultModelOption.disabled = true;
    modelSelect.appendChild(defaultModelOption);
    modelSelect.disabled = true;
    Object.keys(modelProductUrls).forEach(k => delete modelProductUrls[k]);

    // If a Make is already selected, reload models for the new type+make combination
    if (makeSelect.value) {
      await onMakeChange();
    }

    updateSearchButtonState();
  }

  async function onMakeChange() {
    updateSearchButtonState();

    const typeGid = typeSelect.value;
    const makeGid = makeSelect.value;

    // Clear model
    while (modelSelect.options.length > 1) modelSelect.remove(1);
    modelSelect.disabled = true;
    Object.keys(modelProductUrls).forEach(k => delete modelProductUrls[k]);

    if (!makeGid) {
      updateSearchButtonState();
      return;
    }

    modelSelect.classList.add('loading');
    const loadingOption = document.createElement('option');
    loadingOption.value = '';
    loadingOption.textContent = 'Loading models...';
    loadingOption.disabled = true;
    modelSelect.appendChild(loadingOption);

    try {
      await fetchProductUrlsForModels(typeGid, makeGid);

      while (modelSelect.options.length > 1) modelSelect.remove(1);

      const modelEntries = Object.entries(modelProductUrls);

      if (modelEntries.length === 0) {
        while (modelSelect.options.length > 0) modelSelect.remove(0);
        const none = document.createElement('option');
        none.value = '';
        none.textContent = 'No matching Models';
        none.disabled = true;
        none.selected = true;
        modelSelect.appendChild(none);
        modelSelect.disabled = true;
      } else {
        while (modelSelect.options.length > 0) modelSelect.remove(0);

        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = 'Select Model';
        defaultOption.selected = true;
        modelSelect.appendChild(defaultOption);

        const modelGids = modelEntries.map(([gid]) => gid);

        const appliedFilters = [];
        if (typeGid) appliedFilters.push({ namespace: FILTER.TYPE.namespace, key: FILTER.TYPE.key, value: typeGid });
        appliedFilters.push({ namespace: FILTER.MAKE.namespace, key: FILTER.MAKE.key, value: makeGid });

        const filters = await fetchFilters(appliedFilters);
        const modelFilterValues = filters.find(f => f.id === FILTER.MODEL.filterId)?.values || [];

        const labelMap = {};
        modelFilterValues.forEach(({ id, label }) => {
          const gid = filterValueIdToGid(id);
          if (gid) labelMap[gid] = label;
        });

        const unlabelledGids = modelGids.filter(gid => !labelMap[gid]);
        if (unlabelledGids.length > 0) {
          const metaobjectLabels = await fetchMetaobjectLabels(unlabelledGids);
          Object.assign(labelMap, metaobjectLabels);
        }

        const options = modelEntries
          .map(([gid]) => ({ gid, label: labelMap[gid] || gid }))
          .sort((a, b) => a.label.localeCompare(b.label));

        options.forEach(({ gid, label }) => {
          const option = document.createElement('option');
          option.value = gid;
          option.textContent = label;
          modelSelect.appendChild(option);
        });

        modelSelect.disabled = false;

        const searchButton = document.getElementById('ssweb-search');
        if (searchButton) searchButton.disabled = false;
      }
    } catch (error) {
      console.error('Error loading models:', error);
      while (modelSelect.options.length > 1) modelSelect.remove(1);
      const errorMsg = document.createElement('option');
      errorMsg.value = '';
      errorMsg.textContent = 'Error loading models. Please try again.';
      errorMsg.disabled = true;
      modelSelect.appendChild(errorMsg);
      modelSelect.disabled = true;
    } finally {
      modelSelect.classList.remove('loading');
      updateSearchButtonState();
    }
  }

  typeSelect.addEventListener('change', onTypeChange);
  makeSelect.addEventListener('change', onMakeChange);
  modelSelect.addEventListener('change', updateSearchButtonState);

  updateSearchButtonState();
}

document.addEventListener('DOMContentLoaded', () => {
  initDropdowns();
  setupFormSubmission();
});